import React from 'react';
import { Package, Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { companyInfo, footerLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-950 pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 pb-16 border-b border-slate-800">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <a href="/" className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center">
                <Package className="w-7 h-7 text-slate-900" />
              </div>
              <div>
                <span className="font-bold text-xl text-white tracking-tight">AXIOM</span>
                <span className="block text-xs font-medium text-slate-400 tracking-widest">GLOBAL FREIGHT</span>
              </div>
            </a>
            <p className="text-slate-400 mb-6 leading-relaxed max-w-md">
              Your trusted partner for seamless global freight solutions. Delivering
              excellence across air, ocean, and ground transportation worldwide.
            </p>
            <div className="space-y-3">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors">
                <Phone className="w-4 h-4" />
                <span>{companyInfo.phone}</span>
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors">
                <Mail className="w-4 h-4" />
                <span>{companyInfo.email}</span>
              </a>
              <div className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>{companyInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Solutions Links */}
          <div>
            <h4 className="font-bold text-white mb-6">Solutions</h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-bold text-white mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-bold text-white mb-6">Stay Updated</h4>
            <p className="text-slate-400 text-sm mb-4">
              Subscribe to our newsletter for industry updates and logistics insights.
            </p>
            <div className="flex gap-2">
              <Input
                type="email"
                placeholder="Enter email"
                className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 focus:border-amber-500 focus:ring-amber-500"
              />
              <Button className="bg-amber-500 hover:bg-amber-600 text-slate-900 px-3">
                <ArrowRight className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-slate-500 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {[
              { icon: Facebook, href: '#' },
              { icon: Twitter, href: '#' },
              { icon: Linkedin, href: '#' },
              { icon: Instagram, href: '#' }
            ].map((social, index) => (
              <a
                key={index}
                href={social.href}
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-slate-400 hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-6 text-sm">
            <a href="#privacy" className="text-slate-500 hover:text-amber-400 transition-colors">
              Privacy Policy
            </a>
            <a href="#terms" className="text-slate-500 hover:text-amber-400 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>

        {/* JCtrans Partner Logo */}
        <div className="mt-8 pt-8 border-t border-slate-800 flex justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_air-cargo-axiom/artifacts/wtmlfv4j_160312-JC%20Rising-logo.png" 
            alt="JCtrans Partner" 
            className="h-24 object-contain opacity-90 hover:opacity-100 transition-opacity"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
